import {getReviewNumeralEnding} from "../utils/get-numeral-ending";
import AbstractComponent from "./abstract-component";

const createTemplate = (className, count, isShowEnding) => {
  return (
    `<button class="${className}__comments-count comments-count" type="button">
      <svg aria-hidden="true" width="24" height="24">
        <use href="sienge/img/sprite.svg#icon-comment"></use>
      </svg>
      ${isShowEnding
      ? `<span>${getReviewNumeralEnding(count)}</span>`
      : `<span>${count}</span>`}
    </button>`
  );
};

export default class CommentsCountComponent extends AbstractComponent {
  constructor({className = ``, count = 0, isShowEnding = true}) {
    super();

    this._className = className;
    this._count = count;
    this._isShowEnding = isShowEnding;
  }

  getTemplate() {
    return createTemplate(this._className, this._count, this._isShowEnding);
  }

  setClickHanlder(handler) {
    this.getElement().addEventListener(`click`, handler);
  }
}
